class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.boundOverlayClick = this.close.bind(this);
    this.bindOverlay();
    this.setHeaderCartIconAccessibility();
  }

  bindOverlay() {
    const overlay = this.querySelector('#CartDrawer-Overlay');
    if (!overlay) return;

    overlay.removeEventListener('click', this.boundOverlayClick);
    overlay.addEventListener('click', this.boundOverlayClick);
  }

  setHeaderCartIconAccessibility() {
    this.cartLink = document.querySelector('#cart-icon-bubble');
    if (!this.cartLink) return;

    this.cartLink.setAttribute('role', 'button');
    this.cartLink.setAttribute('aria-haspopup', 'dialog');
    this.cartLink.setAttribute('aria-controls', 'CartDrawer');
    this.cartLink.setAttribute('aria-expanded', 'false');
    this.cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(this.cartLink);
    });
    this.cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(this.cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    requestAnimationFrame(() => {
      this.classList.add('animate', 'active');
      this.cartLink?.setAttribute('aria-expanded', 'true');
      this.activateFocusTrap();
    });

    document.body.classList.add('overflow-hidden');
  }

  activateFocusTrap() {
    const containerToTrapFocusOn = this.classList.contains('is-empty')
      ? this.querySelector('.drawer__inner-empty')
      : document.getElementById('CartDrawer');
    const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');

    if (containerToTrapFocusOn && focusElement) trapFocus(containerToTrapFocusOn, focusElement);
  }

  close() {
    this.classList.remove('active');
    this.cartLink?.setAttribute('aria-expanded', 'false');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    if (typeof parsedState.item_count === 'number') this.classList.toggle('is-empty', parsedState.item_count === 0);
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionHTML = parsedState.sections?.[section.id];
      if (!sectionHTML) return;

      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      const sectionInnerHTML = this.getSectionInnerHTML(sectionHTML, section.selector);
      if (sectionInnerHTML == null) return;
      sectionElement.innerHTML = sectionInnerHTML;
    });

    const renderedDrawer = new DOMParser()
      .parseFromString(parsedState.sections?.['cart-drawer'] || '', 'text/html')
      .querySelector('cart-drawer');
    if (renderedDrawer) this.classList.toggle('is-empty', renderedDrawer.classList.contains('is-empty'));

    this.bindOverlay();
    window.tpgCartMutationLock?.refresh();
    this.open();
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector)?.innerHTML ?? null;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    if (element?.closest?.('.tpg-empty-cart-recovery')) {
      this.activeElement = this.cartLink;
      return;
    }

    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
